var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPinDesktop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "16px",
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPinDesktop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icPinDesktop",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 9.14285714,
    cy: 9.14285714,
    r: 6.85714286
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pin",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(5.500000, 5.500000) scale(-1, 1) translate(-5.500000, -5.500000) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.2,8.8 L0,11",
    id: "Stroke-1",
    stroke: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,6.24377224 L4.75622776,11 C5.76749703,9.98873072 6.00237248,8.4881376 5.44780546,7.2485172 L8.66429419,4.03202847 C9.47330961,4.24733096 10.3671412,4.04507711 11,3.41221827 L7.58778173,0 C6.96144721,0.62633452 6.75266904,1.52016607 6.96144721,2.32265718 L3.73843416,5.54567023 C2.49881376,4.99762752 1.00474496,5.23250297 0,6.24377224 Z",
    id: "Stroke-3",
    stroke: "#535453",
    fill: "#535453",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPinDesktop);
export default __webpack_public_path__ + "static/media/icPinDesktop.d4d8edfff04ac31de554acdc1437a110.svg";
export { ForwardRef as ReactComponent };